import request from "../../utils/Request";
import {BaseEndpoints} from "./endpoints";

const export_data = async (params: string, data: any) => {
  const url = `${BaseEndpoints.BASE_ADMIN_LOG_URI}export/?${params}`;
  const response = await request.authorizedAxios().post(url, data);
  return response;
}


const BaseService = {
  export_data,
}

export default BaseService;
